import React from "react";
import { COLORS, EDUCATION, AWARDS } from "../data/profile";
import { useLang } from "../LanguageContext";
import ScrollReveal from "./ScrollReveal";

export default function Credentials() {
  const { lang } = useLang();
  const awards = AWARDS[lang] || AWARDS.en;

  return (
    <section className="credentials-section">
      <div className="section-inner">
        <ScrollReveal>
          <h2 className="section-heading">
            {lang === "en" ? "Credentials" : "Diplômes & Distinctions"}
          </h2>
        </ScrollReveal>

        <div className="credentials-grid">
          <ScrollReveal delay={0}>
            <div className="credential-group">
              <h3 className="credential-group-title">
                {lang === "en" ? "Education" : "Formation"}
              </h3>
              {EDUCATION.map((edu, i) => (
                <div key={i} className="credential-item">
                  <div className="credential-degree">{edu.degree}</div>
                  <div className="credential-school">{edu.school}</div>
                  <div className="credential-year">{edu.year}</div>
                </div>
              ))}
            </div>
          </ScrollReveal>

          <ScrollReveal delay={150}>
            <div className="credential-group">
              <h3 className="credential-group-title">
                {lang === "en" ? "Awards & Recognition" : "Prix & Reconnaissance"}
              </h3>
              {awards.map((award, i) => (
                <div key={i} className="credential-item">
                  <div className="credential-degree">{award}</div>
                </div>
              ))}
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
}
